module.exports = __webpack_public_path__ + "static/img/252_phase_function_Paper_PointsHejduk_Prediction.667153f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/252_phase_function_Paper_PointsHejduk_Prediction.png
// module id = prgE
// module chunks = 0